import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CompassTwoToneSvg from "@ant-design/icons-svg/es/asn/CompassTwoTone";
import AntdIcon from '../components/AntdIcon';
var CompassTwoTone = function CompassTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: CompassTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(CompassTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CompassTwoTone';
}
export default RefIcon;